<template>
  <v-container fluid class="pt-0">
    <base-material-card color="primary" icon="mdi-chart-scatter-plot" inline class="ml-0 px-5 py-4" :title="titulo">
      <v-btn
        v-if="accessReleased('ANALISES_SETORIZADAS_ADICIONAR')"
        id="btn-nova-analise"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push('add')"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        Nova Análise
      </v-btn>
      <v-text-field
        id="analises-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <v-divider class="mt-10" />
      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :mobile-breakpoint="800"
        :loading="loading"
        :hide-default-header="loading"
        :hide-default-footer="loading"
        no-data-text="Nenhuma análise disponível"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate-column" v-bind="attrs" v-on="on">
                {{ item.nome }}
              </div>
            </template>
            <span>{{ item.nome }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.setorizacao_nome`]="{ item }">
          <span id="setorizacao-nome">
            {{ item.setorizacao_nome }}
          </span>
        </template>
        <template v-slot:[`item.mes`]="{ item }">{{ item.mes | formatToMonth }} v{{ item.versao }}</template>
        <template v-slot:[`item.numero_setores`]="{ item }">
          <span id="numero-setores">
            {{ item.numero_setores | parseNumberToIntegerBR }}
          </span>
        </template>
        <template v-slot:[`item.ultima_execucao`]="{ item }">
          {{ item.ultima_execucao | parseToDateTimeBR }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            v-if="accessReleased('ANALISES_SETORIZADAS_VIZUALIZAR_MAPA')"
            id="action-visualizar"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            :disabled="item.status != 'SUCESSO'"
            color="gray"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            @click="$router.push(`visualizar-mapa/${item.id}`)"
          >
            <v-icon small>mdi-eye-outline</v-icon>
          </v-btn>
          <v-btn
            id="action-favoritar-rel"
            class="ml-n1 px-1"
            :color="item.favorito ? 'primary' : 'gray'"
            min-width="0"
            fab
            icon
            x-small
            @click="favoritar(item)"
          >
            <v-icon small>mdi-star</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-rel"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="canRunItem(item)" @click="executarItem(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-play</v-icon>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="canEditItem(item) && accessReleased('ANALISES_SETORIZADAS_EDITAR')"
                @click="$router.push(`editar/${item.id}`)"
              >
                <v-list-item-title>
                  <v-icon small>mdi-pencil</v-icon>
                  Editar
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDeleteItem(item)" @click="openDialogDelete(item.id, item.nome)">
                <v-list-item-title>
                  <v-icon small>mdi-trash-can-outline</v-icon>
                  Deletar
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="
                  ((dialogCreationLog = true),
                  (dialogCreationLogData = {
                    username: item.usuario,
                    created: item.created
                  }))
                "
              >
                <v-list-item-title>
                  <v-icon small>mdi-table-search</v-icon>
                  Log
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer.page-text`]>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" v-bind="attrs" v-on="on" @click="$emit('rechargeTable')">mdi-refresh</v-icon>
            </template>
            <span>Clique aqui para recarregar as análises</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-creation-log :dialog.sync="dialogCreationLog" :item="dialogCreationLogData" />
    <dialog-delete :dialog.sync="dialogDelete" @submitTriggered="deletarItem(dialogDeleteData.id)">
      <template slot="title">Deletar Análise #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar a análise setorizada
        <strong>{{ dialogDeleteData.titulo }}</strong>
        ?
      </template>
    </dialog-delete>
  </v-container>
</template>

<script>
  import AnalisesSetorizadasService from '@/services/AnalisesSetorizadasService';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins';
  import profilePermissionsMixin from '@/mixins/profilePermissionsMixin';

  export default {
    components: {
      DialogCreationLog: () => import('@/components/general/DialogCreationLog'),
      DialogDelete: () => import('@/components/general/DialogDelete'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue')
    },
    mixins: [powerupsActionsMixins, profilePermissionsMixin],

    props: {
      titulo: {
        type: String,
        default: 'Análises Setorizadas'
      },
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      powerupService: AnalisesSetorizadasService,
      powerupEntityName: 'Análise Setorizada',
      search: '',
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Setorização',
          value: 'setorizacao_nome'
        },
        {
          text: 'Mês dos dados',
          value: 'mes'
        },
        {
          text: 'Nº de setores',
          value: 'numero_setores'
        },
        {
          text: 'Executado',
          value: 'ultima_execucao'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ]
    }),

    methods: {
      favoritar(item) {
        AnalisesSetorizadasService.favoritar(item.id)
          .then(() => (item.favorito = !item.favorito))
          .catch(() =>
            this.$toast.error('Erro ao tentar favoritar/desfavoritar.', '', {
              position: 'topRight'
            })
          );
      }
    }
  };
</script>

<style>
  .truncate-title-rt {
    width: 600px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .fs-rt {
    font-size: 1.5625rem;
  }
  @media screen and (max-width: 1100px) {
    .truncate-title-rt {
      width: 550px;
    }
  }
  @media screen and (max-width: 800px) {
    .fs-rt {
      font-size: 1.2625rem;
    }
    .truncate-title-rt {
      width: 350px;
    }
  }
  @media screen and (max-width: 550px) {
    .fs-rt {
      font-size: 1.12rem;
    }
  }
</style>
